function pushProductDetail(name, productId, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      ecommerce: {
        detail: {
          products: [
            {
              // List of productFieldObjects.
              name: name, // Name or ID is required.
              id: productType + "|" + donationType + "|" + productId,
              quantity: '1',
              'category': productType,
              'variant': donationType,
            }
          ]
        }
      }
    });
  }
}

function pushProductImpression(name, productId, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      ecommerce: {
        impressions: {
          products: [
            {
              // List of productFieldObjects.
              name: name, // Name or ID is required.
              id: productType + "|" + donationType + "|" + productId,
              quantity: '1',
              'category': productType,
              'variant': donationType,
            }
          ]
        }
      }
    });
  }
}

function pushAddToCart(name, productId, price, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      event: "addToCart",
      ecommerce: {
        currencyCode: "AUD",
        add: {
          products: [
            {
              // List of productFieldObjects.
              name: name, // Name or ID is required.
              id: productType + "|" + donationType + "|" + productId,
              price: price,
              quantity: "1",
              'category': productType,
              'variant': donationType
            }
          ]
        }
      }
    });
  }
}

function pushRemoveFromCart(name, productId, price, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      event: "removeFromCart",
      ecommerce: {
        currencyCode: "AUD",
        add: {
          products: [
            {
              // List of productFieldObjects.
              name: name, // Name or ID is required.
              id: productType + "|" + donationType + "|" + productId,
              price: price,
              quantity: "1",
              'category': productType,
              'variant': donationType
            }
          ]
        }
      }
    });
  }
}

function pushCheckout(name, productId, price, productType, donationType) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      event: "checkout",
      ecommerce: {
        currencyCode: "AUD",
        checkout: {
          products: [
            {
              // List of productFieldObjects.
              name: name, // Name or ID is required.
              id: productType + "|" + donationType + "|" + productId,
              price: price,
              quantity: "1",
              'category': productType,
              'variant': donationType
            }
          ]
        }
      }
    });
  }
}

function pushPurchase(transactionId, name, productId, productType, donationType, price, postcode, paymentType, callback) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': transactionId,
            'affiliation': 'WWF Online Shop',
            'revenue': price,
            'tax': '0.00',
            'shipping': '0.00',
          },
          'products': [{ // List of productFieldObjects.
            'name': name, // Name or ID is required.
            'id': productType + "|" + donationType + "|" + productId,
            'price': price,
            'category': productType,
            'variant': donationType,
            'quantity': '1',
            'dimension4': postcode,
            'dimension5': paymentType
          }],
        }
      },
      'eventCallback': callback ? callback() : () => { }
    });
  }
}

function formSubmitEvent(formName) {
  if (window.dataLayer != undefined) {
    window.dataLayer.push({
      formName: formName,
      event: "formSubmitEvent",
    });
  }
}

function formSubmitSuccessEvent(formName, callback) {
  if (window.dataLayer != undefined) {
    console.log('Pushed form submit');
    window.dataLayer.push({
      formName: formName,
      event: "formSubmitSuccessEvent",
      'eventCallback': callback ? callback() : () => { }
    });
  }
}

export default {
  pushProductDetail,
  pushProductImpression,
  pushAddToCart,
  pushRemoveFromCart,
  pushCheckout,
  pushPurchase,
  formSubmitEvent,
  formSubmitSuccessEvent
}


// WEBPACK FOOTER //
// ./src/utils/gtm.js